import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_product_image: { message: "idle" },
};

export const update_tenant_product_image_Slice = createSlice({
 name: "update_tenant_product_image",
 initialState,
 reducers: {
  success_update_tenant_product_image: (state, action) => {
   state.update_tenant_product_image = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_product_image: (state, action) => {
   state.update_tenant_product_image = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_product_image: (state) => {
   state.update_tenant_product_image = { status: app_consts.IDLE };
  },
  loading_update_tenant_product_image: (state) => {
   state.update_tenant_product_image = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_product_image, fail_update_tenant_product_image, reset_update_tenant_product_image, loading_update_tenant_product_image } = update_tenant_product_image_Slice.actions;

export default update_tenant_product_image_Slice.reducer;